/**
 * App.jsx
 *
 * Root layout component for all authenticated routes.
 * Renders the main content area via React Router's <Outlet />
 * and the shared DashNavRail bottom navigation (except on Home page,
 * which has its own inline nav rail).
 *
 * The gradient background is now applied at the page-shell level
 * (via PageShell), not here — so App is a neutral wrapper.
 */
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {Outlet, useLocation} from 'react-router';
import DashNavRail from './components/DashNavRail';

function App() {
  const location = useLocation();
  /**
   * Home page has its own built-in inline nav rail with active state styling,
   * so we skip rendering the shared DashNavRail on the Home route to avoid
   * duplicate nav bars.
   */
  const isHome = location.pathname === '/' || location.pathname === '/dashboard';

  return (
    <div className="App">
      <div className="main-content">
        <Outlet />
      </div>
      {/* Shared frosted glass nav rail — consistent across all non-Home pages */}
      {!isHome && <DashNavRail />}
    </div>
  );
}

export default App;
